import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { StyledTableCell, useStyles } from "../Tables.styles";
import { TableFooterPagination } from "../TableFooterPagination/TableFooterPagination";
import { TableBodySkeleton } from "../../../components/Skeletons/Tables/TableBody/TableBody";
import { tableStore } from "../../../mobx/stores/TableStore/TableStore";
import { TutorsProfilesTableRow } from "./TutorsProfilesTableRow/TutorsProfilesTableRow";

interface TutorsProfilesTableProps {
  loading: boolean;
}

export const TutorsProfilesTable = observer(({ loading }: TutorsProfilesTableProps) => {
  const classes = useStyles();
  const { users, page } = tableStore;
  const { per_page } = page;
  const userInfo = Object.values(users)
    .filter((x) => !x.deleted_at)
    .slice(0, per_page);

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell width={20}>Id</StyledTableCell>
                <StyledTableCell>Имя</StyledTableCell>
                <StyledTableCell>Роль</StyledTableCell>
                <StyledTableCell>Дата создания</StyledTableCell>
                <StyledTableCell>Дата Обновления</StyledTableCell>
                <StyledTableCell width={80} />
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBodySkeleton rows={per_page} cols={6} />
            ) : (
              <TableBody>
                {userInfo.map((user) => (
                  <TutorsProfilesTableRow user={user} key={user.id} />
                ))}
              </TableBody>
            )}
            <TableFooterPagination colSpan={6} />
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
});
